import Vue from "vue";
import Vuex from "vuex";
import shipping_lines from "./modules/shipping_lines";
import vessels from "./modules/vessels";
import radio_log from "./modules/radio_log";
import activities from "./modules/activities";
import chief_log from "./modules/chief_log";
import countries from "./modules/countries";
import act_types from "./modules/activity_types";
import manifest from "./modules/manifest";
import cargoes from "./modules/cargoes";
import consignees from "./modules/consignees";
import users from "./modules/users";
import user_groups from "./modules/user_groups";
import auth from "./modules/auth.module";
import department from "./modules/department";
import employee from "./modules/employee";
import dependent from "./modules/dependents";
import department_units from "./modules/department_units";
import insurance from "./modules/insurance";
import departed_vessels from "./modules/departed_vessels";
import delivery_orders from "./modules/delivery_orders";
import reporting from "./modules/reporting";
import apps from "./modules/apps";
import clinics from "./modules/clinics";
import createLogger from "vuex/dist/logger";

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== "production";

export default new Vuex.Store({
  modules: {
    shipping_lines,
    vessels,
    radio_log,
    activities,
    chief_log,
    countries,
    act_types,
    manifest,
    cargoes,
    consignees,
    users,
    user_groups,
    department,
    auth,
    employee,
    dependent,
    department_units,
    insurance,
    departed_vessels,
    delivery_orders,
    reporting,
    apps,
    clinics
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
});
